import React from 'react';
import IconBase from './IconBase';
const InfoIcon = props => React.createElement(IconBase, props, React.createElement("g", null, React.createElement("defs", null, React.createElement("polygon", {
  points: "-507,-1597.791 -508.209,-1599 -513,-1594.209 -517.791,-1599 -519,-1597.791 -514.209,-1593 -519,-1588.209 -517.791,-1587 -513,-1591.791 -508.209,-1587 -507,-1588.209 -511.791,-1593 \t\t"
})), React.createElement("g", null, React.createElement("defs", null, React.createElement("rect", {
  x: "-688",
  y: "-3317",
  width: "1440",
  height: "6698"
})))), React.createElement("path", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M31.893,5.895 c-14.105,0-25.542,11.472-25.542,25.626c0,14.154,11.437,25.626,25.542,25.626c14.105,0,25.542-11.472,25.542-25.626 C57.435,17.367,45.999,5.895,31.893,5.895z"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x1: "32.037",
  y1: "46.398",
  x2: "32.037",
  y2: "26.771"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x1: "31.952",
  y1: "17.388",
  x2: "31.952",
  y2: "15.909"
}));
InfoIcon.displayName = 'InfoIcon';
export default InfoIcon;
//# sourceMappingURL=InfoIcon.js.map